import React, { useEffect, useState } from 'react';  
import { useParams } from 'react-router-dom';  
import { fetchNewHarvestImage } from './api'; // ここで関数をインポートします。  
import { StyledImage } from './styles'; // ここでスタイルをインポートします。  
import Loading from '../components/Loading_robo'; // Loadingコンポーネントをインポート  
import styled from 'styled-components';  
import { useNavigate } from 'react-router-dom';
  
const Container = styled.div`  
  display: flex;  
  flex-direction: column;  
  align-items: center;  
  padding: 20px;  
  min-height: 100vh;  
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;  
  color: green;  
  text-align: center;  
`;  
  
const Button = styled.button`  
  margin-top: 10px;  
  width: 100%;  
  padding: 10px;  
  font-size: 16px;  
  background-color: green;  
  color: white;  
  border: none;  
  border-radius: 5px;  
  cursor: pointer;  
  align-self: center;  
`;
  
const GridContainer = styled.div`  
  display: grid;  
  grid-template-columns: repeat(3, 1fr);  
  gap: 20px;  
  margin-bottom: 20px;  
  
  @media (max-width: 768px) {  
    grid-template-columns: 1fr;  
  }  
`;  
  
const ImageContainer = styled.div`  
  display: flex;  
  flex-direction: column;  
  align-items: center;  
`;  
  
function NewHarvestImagePage() {  
  const { id } = useParams();  
  const [images, setImages] = useState([]);  
  const [loading, setLoading] = useState(true);  
  const [error, setError] = useState(null);  

  const navigate = useNavigate();
  const handleBack = () => {
    try {
        navigate(-1);
    } catch (error) {
        console.error('Error navigating back:', error);
    }
};
  
  useEffect(() => {  
    fetchNewHarvestImage(id, 27)  
      .then(setImages)  
      .catch(e => {  
        setError(e.message);  
      })  
      .finally(() => {  
        setLoading(false);  
      });  
  }, [id]);  
  
  if (loading) {  
    return <Loading />; // ロード中はLoadingコンポーネントを表示  
  }  
  
  if (error) {  
    return <Container>Error: {error}</Container>;  
  }  
  
  return (  
    <Container>  
      <h1>収穫画像履歴</h1>  
      <p>{id}</p>  
      <GridContainer>  
        {images.map((image, index) => (  
          <ImageContainer key={index}>  
            <StyledImage src={`data:image/jpeg;base64,${image.data}`} alt={`テレメトリーデータ画像番号 ${index + 1}`} />  
            <p>{image.name}</p>  
          </ImageContainer>  
        ))}  
      </GridContainer>  
      <Button onClick={handleBack}>前の画面に戻る</Button>  
    </Container>  
  );  
}  
  
export default NewHarvestImagePage;  
